/* eslint-disable camelcase */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CloseIcon from "@sunSource/Icons/CloseIcon";
import CustomApplicationState from "@sunSource/Store/CustomApplicationState";
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface Props {
    productId?: string;
    vendor: string;
    supplier?: string;
    model?: string;
}

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => {
    return {
        userPhoneNumber: state.context.session?.properties?.phoneNumber ?? state.context.session?.properties?.phone,
        userCompanyName: state.context.session?.properties?.companyName,
        userName: state.context.session?.userName,
        userFirstName: state.context.session?.firstName,
        userLastName: state.context.session?.lastName,
        isAuthenticated: state.context.session?.isAuthenticated,
    };
};
type OwnProps = Props & HasProduct & ReturnType<typeof mapStateToProps>;

export interface INTHubSpotWidgetStyles {
    hubSpotWidgetMain?: InjectableCss;
    mainDivWrapper?: InjectableCss;
    mainDiv?: InjectableCss;
    sectionOne?: InjectableCss;
}

export const iNTHubSpotWidgetStyles: INTHubSpotWidgetStyles = {
    mainDivWrapper: {
            css: css`
                background: #275aa8;
                .closeButton {
                    display: none;
                }
    
                .modalContent {
                    background: #00000061;
                    padding: 15px;
                    position: fixed;
                    width: 100%;
                    height: 100vh;
                    left: 0px;
                    top: 0px;
                    display: flex;
                    justify-content: center;
                    padding-top: 15px;
                    overflow-y: auto;
                    .closeButton {
                        position: absolute;
                        padding: 5px 10px;
                        right: 15px;
                        top: 15px;
                        display: block;
                        background: #ffffff;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: black;
    
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    right: -3px;
                                    top: -5px;
                                `,
                                null,
                                null,
                                null,
                                null,
                            ])}
                    }
                }
            `,
        },
    mainDiv: {
        css: css`
            background: #275aa8;
            padding: 16px;
            border-radius: 3px;
        `,
    },
    sectionOne: {
        css: css`
            > h2 {
                font-size: 30px;
                color: #fff;
                margin: 0px 0px 7px 0px;
            }
            > p {
                font-size: 15px;
                color: #fff;
                margin: 0px 0px 15px 0px;
            }
        `,
    },
    hubSpotWidgetMain: {
        css: css`
            > form > fieldset > div > label {
                color: #ffff;
                margin-top: 5px;
                > .hs-form-required {
                    color: red;
                    padding-left: 1px;
                }
            }
            > form > fieldset > div {
                margin-bottom: 11px;
            }
            > form > fieldset > div > ul > li > .hs-error-msg {
                color: #f1eb36;
                font-size: 13px;
            }
            > form > div > ul > li > .hs-main-font-element {
                color: #f1eb36;
                margin-top: 10px;
            }
            > form > div > ul {
                margin-top: 15px;
                text-align: center;
            }
            > form > fieldset > div > div > ul > li > .hs-error-msg {
                color: #f1eb36;
                font-size: 13px;
            }
            > form > .hs_submit {
                margin: 24px 0px 0px 0px;
                text-align-last: center;
            }
            > form > .hs_recaptcha {
                text-align: -webkit-center;
                margin-top: 4px;
            }
            > form > div > div:nth-child(2) {
                > .hs-button {
                    padding: 10px 8px;
                    width: 80%;
                    color: #fff;
                    background: #363636;
                    border: none;
                    text-transform: uppercase;
                    font-weight: 600;
                    letter-spacing: 0.3px;
                    border-radius: 3px;
                    font-family: inherit;
                }
                > .hs-button:hover {
                    color: #363636;
                    background: #fff;
                    border: none;
                }
            }
            > form fieldset {
                > div > div > input {
                    padding: 3px 4px;
                    width: 100% !important;
                    background-color: #dfd9d9fc;
                    height: 30px;
                    border: none;
                    border-radius: 2px;
                    font-family: inherit;
                }
                > div > div > input:focus {
                    background-color: white;
                }
                > div > div > div > input:focus {
                    background-color: white;
                }
                > div > div > div > input {
                    padding: 3px 4px;
                    width: 100% !important;
                    background-color: #dfd9d9fc;
                    height: 33px;
                    border: none;
                }
                > div > div > div > input[type="file"] {
                    color: white;
                    background: none;
                }
                > div > div > textarea {
                    min-height: 100px;
                    margin-top: 3px;
                    width: 100% !important;
                    background-color: #dfd9d9fc;
                    border-radius: 3px;
                    font-family: inherit;
                }
                > div > div > textarea:focus {
                    background-color: white;
                }
                > div > div > div > ul > li {
                    padding: 3px 0px;
                    color: #ffff;
                }
                > div > div > label > span {
                    color: #ffff;
                }
                > div > div > label .hs-form-required {
                    color: red;
                    padding-left: 1px;
                }
                > div > div > div > select {
                    padding: 4px 4px;
                    width: 100% !important;
                    margin-top: 3px;
                    background-color: #dfd9d9fc;
                    height: 33px;
                    border: none;
                    border-radius: 2px;
                    font-family: inherit;
                }
                > div > div > div > select:focus {
                    background-color: white;
                }
            }
            > form {
                > .form-columns-2 {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                > .form-columns-2 > div {
                    width: 48% !important;
                    float: initial !important;
                    > div > input {
                        width: 100% !important;
                    }
                }
            }
        `,
    },
};

const styles = iNTHubSpotWidgetStyles;

const INTHubSpotComponent: React.FunctionComponent<OwnProps> = props => {
    const { userPhoneNumber, userCompanyName, userName, userFirstName, userLastName, isAuthenticated } = props;

    const loadHubSpotForm = () => {
        if (typeof window !== undefined) {
            const script = document.createElement("script");
            script.src = "https://js.hsforms.net/forms/embed/v2.js";
            document.body.appendChild(script);
            script.addEventListener("load", () => {
                if ((window as any).hbspt !== undefined) {
                    (window as any).hbspt.forms.create({
                        // region: siteMessage("hubspot_Region"),
                        // portalId: siteMessage("hubspot_PortalId"),
                        // formId: siteMessage("hubspot_FormId"),
                        region: siteMessage("na1"),
                        portalId: siteMessage("24145943"),
                        formId: siteMessage("5170b21b-d7df-4080-8988-d87498bb098d"),
                        target: "#buynowhubspot",
                        onFormSubmitted: function() {
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                            }
                        
                    });
                }
            });

            window.addEventListener("message", event => {
                if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormReady") {
                    fetch("https://api.ipify.org?format=json")
                        .then(response => response.json())
                        .then(data => {
                            const modalHubspot = document.querySelector("#buynowhubspot");
                            const ipAddressField = modalHubspot?.getElementsByClassName("hs_ip_address");
                            if (ipAddressField && ipAddressField.length > 0) {
                                ipAddressField[0].setAttribute(
                                    "style",
                                    "display: block; position: absolute; left: -5000px; top: -5000px;",
                                );
                            }
                            const hiddenField = modalHubspot?.querySelector('input[name="ip_address"]');
                            hiddenField?.setAttribute("type", "");

                            if (hiddenField) {
                                hiddenField?.setAttribute("value", data.ip);
                            }

                            const vendorField = modalHubspot?.getElementsByClassName("hs_vendor");
                            if (vendorField && vendorField.length > 0) {
                                vendorField[0].setAttribute(
                                    "style",
                                    "display: block; position: absolute; left: -5000px; top: -5000px;",
                                );
                            }
                            const vendorHiddenField = modalHubspot?.querySelector('input[name="vendor"]');
                            vendorHiddenField?.setAttribute("type", "");

                            if (vendorHiddenField) {
                                vendorHiddenField?.setAttribute("value", props.vendor);
                            }

                            const supplier_formsubmitHiddenField = modalHubspot?.querySelector(
                                'input[name="supplier_formsubmit"]',
                            );
                            if (supplier_formsubmitHiddenField) {
                                supplier_formsubmitHiddenField?.setAttribute("type", "text");
                                supplier_formsubmitHiddenField?.setAttribute(
                                    "placeholder",
                                    props.supplier ? "Loading..." : "Suppliers",
                                );
                            }

                            const model_seriesHiddenField = modalHubspot?.querySelector('input[name="model_series"]');
                            if (model_seriesHiddenField) {
                                model_seriesHiddenField?.setAttribute("type", "text");
                                model_seriesHiddenField?.setAttribute(
                                    "placeholder",
                                    props.model ? "Loading..." : "Model",
                                );
                            }

                            const recent_conversion_form_page_url = modalHubspot?.querySelector(
                                'input[name="recent_conversion_form_page_url"]',
                            );
                            if (recent_conversion_form_page_url) {
                                const pageUrl = window.location.href;
                                recent_conversion_form_page_url?.setAttribute("value", pageUrl);
                            }

                            const recent_conversion_form_page_title = modalHubspot?.querySelector(
                                'input[name="recent_conversion_form_page_title"]',
                            );
                            if (recent_conversion_form_page_title) {
                                const pageTitle = document.title;
                                recent_conversion_form_page_title?.setAttribute("value", pageTitle);
                            }

                            if (isAuthenticated && props.productId) {
                                const model_firstname = modalHubspot?.querySelector(
                                    'input[name="firstname"]',
                                ) as HTMLInputElement | null;
                                if (model_firstname) {
                                    model_firstname?.setAttribute(
                                        "placeholder",
                                        userFirstName ? "Loading..." : "First Name",
                                    );
                                }
                                const model_lastname = modalHubspot?.querySelector(
                                    'input[name="lastname"]',
                                ) as HTMLInputElement | null;
                                if (model_lastname) {
                                    model_lastname?.setAttribute(
                                        "placeholder",
                                        userLastName ? "Loading..." : "Last Name",
                                    );
                                }
                                const model_phone = modalHubspot?.querySelector(
                                    'input[name="phone"]',
                                ) as HTMLInputElement | null;
                                if (model_phone) {
                                    model_phone?.setAttribute(
                                        "placeholder",
                                        userPhoneNumber ? "Loading..." : "Phone Numbe",
                                    );
                                }
                                const model_email = modalHubspot?.querySelector(
                                    'input[name="email"]',
                                ) as HTMLInputElement | null;
                                if (model_email) {
                                    model_email?.setAttribute("placeholder", userPhoneNumber ? "Loading..." : "Email");
                                }
                                const model_company = modalHubspot?.querySelector(
                                    'input[name="company"]',
                                ) as HTMLInputElement | null;
                                if (model_company) {
                                    model_company?.setAttribute(
                                        "placeholder",
                                        userCompanyName ? "Loading..." : "Company Name",
                                    );
                                }
                            }

                            if (props.supplier || props.model) {
                                setTimeout(() => {
                                    const supplier_formsubmitHiddenField = modalHubspot?.querySelector(
                                        'input[name="supplier_formsubmit"]',
                                    );
                                    if (supplier_formsubmitHiddenField) {
                                        supplier_formsubmitHiddenField?.setAttribute("type", "text");
                                        supplier_formsubmitHiddenField?.setAttribute("value", `${props.supplier}`);
                                        supplier_formsubmitHiddenField?.setAttribute("placeholder", "Suppliers");
                                    }

                                    const model_seriesHiddenField =
                                        modalHubspot?.querySelector('input[name="model_series"]');
                                    if (model_seriesHiddenField) {
                                        model_seriesHiddenField?.setAttribute("type", "text");
                                        model_seriesHiddenField?.setAttribute("value", `${props.model}`);
                                        model_seriesHiddenField?.setAttribute("placeholder", "Model");
                                    }

                                    if (isAuthenticated) {
                                        const model_firstname = modalHubspot?.querySelector(
                                            'input[name="firstname"]',
                                        ) as HTMLInputElement | null;
                                        if (model_firstname) {
                                            model_firstname?.setAttribute("value", `${userFirstName || ""}`);
                                            model_firstname.focus();
                                        }
                                        const model_lastname = modalHubspot?.querySelector(
                                            'input[name="lastname"]',
                                        ) as HTMLInputElement | null;
                                        if (model_lastname) {
                                            model_lastname?.setAttribute("value", `${userLastName || ""}`);
                                            model_lastname.focus();
                                        }
                                        const model_phone = modalHubspot?.querySelector(
                                            'input[name="phone"]',
                                        ) as HTMLInputElement | null;
                                        if (model_phone) {
                                            model_phone?.setAttribute("value", `${userPhoneNumber || ""}`);
                                            model_phone.focus();
                                        }
                                        const model_email = modalHubspot?.querySelector(
                                            'input[name="email"]',
                                        ) as HTMLInputElement | null;
                                        if (model_email) {
                                            model_email?.setAttribute("value", `${userName || ""}`);
                                            model_email.focus();
                                        }
                                        const model_company = modalHubspot?.querySelector(
                                            'input[name="company"]',
                                        ) as HTMLInputElement | null;
                                        if (model_company) {
                                            model_company?.setAttribute("value", `${userCompanyName || ""}`);
                                            model_company.focus();
                                        }
                                    }
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            console.error(`Error fetching IP address: ${error}`);
                        });
                }
            });
        }
    };

    const removeModalClass = () => {
        document.getElementById("hubspotFormModalComponent")?.classList.remove("modalContent");
        const modalHubspot = document.querySelector("#buynowhubspot");
        const supplier_formsubmitHiddenField = modalHubspot?.querySelector('input[name="supplier_formsubmit"]');
        if (supplier_formsubmitHiddenField) {
            supplier_formsubmitHiddenField?.setAttribute("value", "");
            supplier_formsubmitHiddenField?.setAttribute("placeholder", "Suppliers");
        }

        const model_seriesHiddenField = modalHubspot?.querySelector('input[name="model_series"]');
        if (model_seriesHiddenField) {
            model_seriesHiddenField?.setAttribute("value", "");
            model_seriesHiddenField?.setAttribute("placeholder", "Model");
        }
    };

    useEffect(() => {
        loadHubSpotForm();

        const css = `

 [data-test-selector="requestForQuoteModal"] > div {
    max-height: calc(100vh - 10px);
 }
 [data-test-selector="requestForQuoteModal"]  form fieldset > div {
    margin-bottom: 5px;
 }  
[data-test-selector="requestForQuoteModal"]  form fieldset ul {
   line-height: 15px;
 }  
[data-test-selector="requestForQuoteModal"]  form fieldset .hs-error-msg  {
  font-size: 12px !important;
 } 

[data-test-selector="requestForQuoteModal"]  form fieldset > div > div > div > input {
    border-radius: 2px;
    margin-top: 0px;
    height: 30px;
}
    [data-test-selector="requestForQuoteModal"]  form fieldset > div > div > div > select {
    height: 30px;
    margin: 0px;
}

[data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="lastname"]) {
    min-width: 100%;
}
    [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="email"]) {
    min-width: 100%;
}
    

/* If a fieldset contains a textarea with name="comment", set width to 100% */
[data-test-selector="requestForQuoteModal"]  form fieldset:has(textarea[name="comment"]) {
    width: 100%;
    min-width: 100%;
}

[data-test-selector="requestForQuoteModal"]  form fieldset textarea[name="comment"] {
    min-height: 50px;
}
    

[data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="company"]) {
    width: 50%;
    padding-right: 10px;
    float: left;
}
    [data-test-selector="requestForQuoteModal"]  form fieldset:has(select[name="country_select"]) {
    width: 50%;
    padding-left: 10px;
    float: left;
}

    [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="supplier_formsubmit"]) {
        width: 50%;
    padding-left: 10px;
    float: right;
}
        [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="model_series"]) {
        width: 50%;
    padding-right: 10px;
    float: left;
}
    

 [data-test-selector="requestForQuoteModal"]  form fieldset:has(select[name="industry_select"]) {
    width: 50%;
    padding-right: 10px;
    float: left;
}
 [data-test-selector="requestForQuoteModal"]  form .hs_recaptcha {
   width: 50%;
    display: inline-block;
    float: right;
    padding-top: 5px;
    right: -5px;
    position: relative;
}
    

 [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="zip"]) {
    width: 100% ;
    padding-right: 10px;
    float: left;
    min-width: 100%;
    padding: 0px;
}

 [data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="zip"]) > div{
      display: flex;
    width: 100%;
    min-width: 100%;
    justify-content: space-between;
}

[data-test-selector="requestForQuoteModal"]  form fieldset:has(input[name="zip"]) > div > div{
    flex-grow: 1;
}
    
    
 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] p, label{
   font-size: 13px;
} 
 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] p{
   margin-bottom: 8px;
} 

 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] h2{
    font-size: 18px;
    margin-bottom: 0px;
} 
   [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"]  {
   padding: 8px;
} 

 [data-test-selector="requestForQuoteModal"]  [data-test-selector="modal_ModalContent"] > div > div{
   padding: 8px 15px;
} 

`;

        // Create a <style> element
        const style = document.createElement("style");
        style.type = "text/css";

        // Inject the CSS rule into the <style> element
        style.appendChild(document.createTextNode(css));

        // Append the <style> element to the <head> of the document
        document.head.appendChild(style);

        // Cleanup function to remove the style element when the component unmounts
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <StyledWrapper {...styles.mainDivWrapper}>
            <StyledWrapper
                id="hubspotFormModalComponent"
                onClick={e => {
                    const target = e.target as HTMLElement; // typecast here
                    if (target.id === "hubspotFormModalComponent") {
                        removeModalClass();
                    }
                }}
                className="modal-overlay"
            >
                <StyledWrapper {...styles.mainDiv}>
                    <Button id="closeButton" onClick={() => removeModalClass()} className="closeButton">
                        <Icon src={CloseIcon} />
                    </Button>
                    <StyledWrapper {...styles.sectionOne}>
                        <h2 style={{ fontSize: "21px" }}>{translate("Submit Request for Quote.")}</h2>
                        <p>{translate("Our sales team will contact you for support.")}</p>
                    </StyledWrapper>
                    <StyledWrapper {...styles.hubSpotWidgetMain} id="buynowhubspot"></StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withProduct(INTHubSpotComponent));
